import React__default from 'react';
import PropTypes from 'prop-types';
import { I as Icon } from './index-11bc5ac3.js';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import './_commonjsHelpers-17042db9.js';
import 'moment';

function Label(props) {
  var children = props.children,
    content = props.content,
    ribbonLeft = props.ribbonLeft,
    ribbonRight = props.ribbonRight,
    icon = props.icon,
    inverted = props.inverted,
    className = props.className;
  var color = props.color;
  var allowedColors = ['red', 'orange', 'yellow', 'green', 'blue', 'teal', 'purple', 'pink'];
  color = allowedColors.some(function (validColor) {
    return validColor === color;
  }) ? "bf-label-color-".concat(color) : '';
  var labelClassNames = "bf-label\n        ".concat(color, "\n        ").concat(inverted ? 'bf-label-inverted' : '', "\n        ").concat(ribbonLeft || ribbonRight ? 'bf-label-has-ribbon' : '', "\n        ").concat(ribbonLeft ? 'bf-label-has-ribbon-left' : '', "\n        ").concat(ribbonRight ? 'bf-label-has-ribbon-right' : '', "\n        ").concat(className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: labelClassNames
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-label-content"
  }, icon ? /*#__PURE__*/React__default.createElement(Icon, {
    name: icon,
    size: "small"
  }) : null, content || children, ribbonLeft || ribbonRight ? /*#__PURE__*/React__default.createElement("span", {
    className: "bf-label-ribbon"
  }) : null));
}
Label.defaultProps = {
  children: '',
  content: '',
  ribbonLeft: false,
  ribbonRight: false,
  icon: '',
  inverted: false,
  color: 'green',
  className: ''
};
Label.propTypes = {
  /**
  Label content
   */
  children: nodeOrStringProp,
  /**
  Label content
   */
  content: nodeOrStringProp,
  /**
  Show Label as a left ribbon
   */
  ribbonLeft: PropTypes.bool,
  /**
  Show Label as a right ribbon
   */
  ribbonRight: PropTypes.bool,
  /**
  Add an icon to the Label
   */
  icon: PropTypes.string,
  /**
  Label lighter background
   */
  inverted: PropTypes.bool,
  /**
  Set Label color
   */
  color: PropTypes.string,
  /**
  Custom className
   */
  className: PropTypes.string
};

export default Label;
//# sourceMappingURL=Label.js.map
